import { Component, OnInit, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { ConstantService, ApiService, HelperService, AuthService } from '@app/core';
import * as moment from 'moment';
declare var $: any;

@Component({
  selector: 'app-inspection-table',
  templateUrl: './inspection-table.component.html',
  styleUrls: ['./inspection-table.component.scss']
})
export class InspectionTableComponent implements OnInit, AfterViewInit {
  @Input() data: any;

  inspectionRecords: any = [];
  commissionHistory: any = [];
  previousMonthsCommission = 0;
  userName: any;
  role: any;
  isIndividualSale = true;
  public currentMonth: string;
  public currentYear: string;
  public salesTablePath: string;

  years: any = [];
  months: any = [];

  filterOptions = {
    month: '',
    year: ''
  };
  oTable: any;
  paidCommission: any;
  constructor(
    private apiSvc: ApiService,
    private constantSvc: ConstantService,
    private helperSvc: HelperService,
    private authenticationService: AuthService,
  ) { }

  ngOnInit() {
    const currentUser = this.authenticationService.currentUserValue;
    this.userName = currentUser.userData.first_name + ' ' + currentUser.userData.last_name;

    this.years = this.helperSvc.getYears();
    this.months = this.helperSvc.getMonths();
    this.currentYear = (moment().year().toString());
    this.currentMonth = ('0' + (moment().month() + 1)).slice(-2).toString();
    this.filterOptions.year = this.currentYear;
    this.filterOptions.month = this.currentMonth;
  }

  ngAfterViewInit() {
    this.loadData();
    this.getCommissionHistory();
    this.getPreviousMonthsRemainingCommission();
  }

  loadData() {
    this.apiSvc.getService(this.constantSvc.APIConfig.GETLATESTINSPECTIONREPORT, '?inspector=' + this.userName + '&month=' + this.filterOptions.month + '&year=' + this.filterOptions.year).subscribe(
      res => {
        if (res.Status === 200) {
          this.inspectionRecords = res.Data;
          this.initTable();
        } else {
          this.inspectionRecords = [];
        }
      }, err => { }
    );
  }

  getCommissionHistory() {
    this.apiSvc.getService(this.constantSvc.APIConfig.GETCOMMISSIONHISTORYBYINSPECTOR, '?inspector=' + this.userName + '&month=' + this.filterOptions.month + '&year=' + this.filterOptions.year).subscribe(
      res => {
        if (res.Status === 200) {
          this.commissionHistory = res.Data;
          this.paidCommission = this.commissionHistory.map(t => t.amount).reduce((acc, value) => acc + Number(value), 0);
        } else {
          this.commissionHistory = [];
        }
      }, err => console.log('error in getting sales commission ', err)
    );
  }

  getPreviousMonthsRemainingCommission() {
    this.apiSvc.getService(this.constantSvc.APIConfig.GETINSPECTORPREMONTHCOMM, '?inspector=' + this.userName).subscribe(
      res => {
        if (res.Status === 200) {
          this.previousMonthsCommission = res.commissionAmount;
        } else {
          this.previousMonthsCommission = 0;
        }
      }, err => console.log('error in getting sales commission ', err)
    );
  }


  getTotalCommission() {
    return this.inspectionRecords.map(t => t.commission_amount).reduce((acc, value) => acc + Number(value), 0);
  }

  getRemainingCommission() {
    const total = this.inspectionRecords.map(t => t.commission_amount).reduce((acc, value) => acc + Number(value), 0);
    const paid = this.commissionHistory.map(t => t.amount).reduce((acc, value) => acc + Number(value), 0);
    return total - paid;
  }

  applyFilter() {
    if ($.fn.DataTable.isDataTable('#salesTable')) {
      this.destroyTable();
    }
    this.loadData();
    this.getCommissionHistory();
  }

  isNA(val) {
    return val === 'N/A';
  }

  searchFilter(val) {
    const value = val ? val.trim() : '';
    this.oTable.search(value).draw();
  }

  initTable() {
    $(() => {
      this.oTable = $('#salesTable').DataTable({
        'paging': true,
        'lengthChange': false,
        'searching': true,
        'ordering': true,
        'info': true,
        'autoWidth': false,
        'processing': true,
        'pageLength': 5
      });
    });
  }

  destroyTable() {
    this.oTable.clear().destroy();
  }
}
